let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9AFkd")).then(() => parcelRequire('f9s7v'));